// extracted by mini-css-extract-plugin
module.exports = {"TagPreview":"TagPreview_TagPreview__2OvXq"};